<template>
  <div class="bon-store-select">
    <v-overflow-btn
      :items="storeItems"
      label="Выберите кофейню"
      editable
      v-model="value"
      @change="emitToParent"
      :rules="rulesStore"
    ></v-overflow-btn>
  </div>
</template>


<script>
export default {
  name: 'StoreSelector',
  props: {
    stores: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    value: '',
    rulesStore: [(v) => !!v || 'Пожалуйста, укажите кофейню'],
  }),
  computed: {
    storeItems() {
      if (!this.stores || this.stores.length === 0) {
        return [{ text: 'Нет кофеен для выбранного метро', value: '' }];
      }
      return this.stores;
    },
  },
  watch: {
    stores() {
      this.value = '';
    },
  },
  methods: {
    emitToParent() {
      this.$emit('storeSelected', this.value);
    },
  },
};
</script>
